import { render } from "./product-custom-select.vue?vue&type=template&id=387392cc"
import script from "./product-custom-select.vue?vue&type=script&lang=js"
export * from "./product-custom-select.vue?vue&type=script&lang=js"

import "./product-custom-select.vue?vue&type=style&index=0&id=387392cc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__